import React from 'react';

import {CellPhone} from 'presentation/components/ChangeData/CellPhone';
import {FeaturesEnum, OperationStateTypesEnum} from 'presentation/constants';
import {useChangeDataProfile} from 'presentation/pages/private/hooks';

import {AccordionStateEnum} from '../../store/formAccordionStore/types';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {usePersonalData} from 'presentation/hooks';
import {useChangeDataAlertStore} from '../../store/changeDataAlertStore';
import {validateCellPhone} from 'presentation/utils/validateCellPhone';
import {EmptyAlertEnum} from 'presentation/components/ChangeData/EmptyAlert/constants';
import {MyProfileEnum} from 'main/analytics/gaTagsEnum';

export function CellPhoneField() {
	const {
		changeDataFormState,
		handleChangeDataFocus,
		handleSendPhoneOtpCode,
		isModalOtpConfirmationOpen,
		changingCellphoneState,
		onCancel,
		resetOtpConfirmationModal,
		resetCellphoneErrorBoundary,
	} = useChangeDataProfile();

	const {isEnabled: isNewProfileFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.ADD__PORTAL_FEATURE_NEW_PROFILE,
	);

	const {currentPhone} = usePersonalData();
	const changeDataAlertState = useChangeDataAlertStore(state => state.status);

	const currentPhoneIsInvalid = !validateCellPhone(currentPhone);

	const isFormActive =
		isNewProfileFeatureFlagEnabled ||
		(changeDataFormState.name === AccordionStateEnum.CELLPHONE &&
			changeDataFormState.isFormActive);

	if (
		isNewProfileFeatureFlagEnabled &&
		changingCellphoneState === OperationStateTypesEnum.ERROR
	) {
		return <CellPhone.Error resetErrorBoundary={resetCellphoneErrorBoundary} />;
	}

	if (isFormActive) {
		return (
			<CellPhone.Form
				onCancel={() => onCancel(AccordionStateEnum.CELLPHONE)}
				onSave={handleSendPhoneOtpCode}
				abandonError={isModalOtpConfirmationOpen.isAbandoned}
				resetAbandonError={resetOtpConfirmationModal}
				loading={changingCellphoneState === OperationStateTypesEnum.PENDING}
			/>
		);
	}

	if (currentPhone) {
		return (
			<CellPhone.Data
				data={{cellPhone: currentPhone}}
				onOpenForm={() => handleChangeDataFocus(AccordionStateEnum.CELLPHONE, true)}
				status={changeDataAlertState}
				isPhoneInvalid={currentPhoneIsInvalid}
			/>
		);
	}
	return (
		<CellPhone.Empty
			type={EmptyAlertEnum.CELL_PHONE}
			onClick={() => handleChangeDataFocus(AccordionStateEnum.CELLPHONE, true)}
			dataTagId={MyProfileEnum.CLICK_CADASTRAR_CELULAR}
			inlineStyle
		/>
	);
}
